import React from 'react';

const CandidateJobStatusConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: "/organizationalsetup/candidatestatus",
			component:React.lazy(() => import('./CandidateJobStatus')) 
        }
	]
};

export default CandidateJobStatusConfig;